import { memo, useEffect } from 'react';

import { useLocation } from '@/js/libs/router';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto',
    });
  }, [pathname]);

  return null;
};

export default memo(ScrollToTop);
